import { render, staticRenderFns } from "./DeleteCompany.vue?vue&type=template&id=7ca623d8&v-slot%3Adelete=true&"
import script from "./DeleteCompany.vue?vue&type=script&lang=ts&"
export * from "./DeleteCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports